export const environment = {
  production: true,
  name: 'SUNCREDIT',
  group: 'SUNCREDIT',
  hostUrl: `https://client.gateway.suncredit.com.ua/v1/api/rest`,
  isTestPaymentEnabled: false,
  isInnValidationEnabled: true,
  recaptchaKEY_CODE: '6LdYHAkqAAAAAJKi4iCaOBzoQNYUvPJDf6EaIQIC',
  cookieDomain: '.suncredit.com.ua',
  WEBSITE_URL: 'https://suncredit.com.ua/',
  LOGO: '../assets/images/icons/icon-logo.png',
  LOGO_WHITE: '../assets/images/icons/icon-logo.png',
  PHONES: [
    {
      label: '0800 202 262',
      contact: 'tel:0800202262',
      type: 'CONTACTS.PHONES.PHONE_UA',
    },
    {
      label: '38(063) 020 22 62',
      contact: 'tel:+380630202262',
      type: 'CONTACTS.PHONES.PHONE_UA_NOT_FREE',
    },
  ],
  EMAILS: [
    {
      label: 'info@starfin.com.ua',
      contact: 'mailto:info@starfin.com.ua',
    },
  ],
  GA_TAG: 'CBYZ2946BV',
  partnerLink: 'https://groshi.bez-otkazov.com/?utm_source=sun&utm_medium=refferal&utm_campaign=lk&utm_term=',
  showPhone: false,
  showIVR: true,
  smsViber: false,
  helpCranchKey: '1a5954ed-4cf5-413a-9d04-4da0a7636d43',
  helpCranchOrganization: 'starfin',
  gtmId: 'GTM-W5ZHK4DP',
  initSeon: true,
  initRecaptcha: false,
};
